import * as React from 'react';

/**
 * Whether a section whose parts each read their own list found nothing in any of them (SR-407):
 * each member's part says its count as its read lands (`say`), and the section is empty only once
 * every member it draws has said zero. Until then — a read out, or failed — it is not, so a fold
 * never shuts on a list still on its way, and a failure stays in view.
 */
export function useEmptyParts(memberIds: string[]): {
  empty: boolean;
  say: (participantId: string, count: number) => void;
} {
  const [counts, setCounts] = React.useState<ReadonlyMap<string, number>>(new Map());
  const say = React.useCallback((participantId: string, count: number) => {
    setCounts((now) =>
      now.get(participantId) === count ? now : new Map(now).set(participantId, count)
    );
  }, []);
  const empty = memberIds.length > 0 && memberIds.every((id) => counts.get(id) === 0);
  return { empty, say };
}
